import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { PreviewIcon } from '@ui/kit/icons';
import { CSSRefTransition } from '@utils/react';
import { previewCls, contentWrapperCls, iconCls, textCls, imageCls } from './atom.preview.style.js';
import { Throbber } from './atom.throbber.js';
import { fadeInCls, FADE_TRANSITION_DURATION_MS } from './comp.content.style.js';
import { usePreviewImage } from './hook.preview-image.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Preview(props) {
  const ref = useRef(null);
  const [previewImageSrc, isGExportImage, didError] = usePreviewImage({
    componentRef: ref,
    previewImageSrc: props.previewImageSrc,
    displayData: props.displayData,
    forceOpenInLightbox: props.forceOpenInLightbox ?? false,
    isRenderingIframe: props.isRenderingIframe
  }, props.onPreviewImageLoaded);
  return /*#__PURE__*/jsx("button", {
    ref: ref,
    onClick: props.onClick,
    "aria-label": `Aktiver ${props.title?.trim() || "opgaven"}`,
    className: previewCls,
    children: /*#__PURE__*/jsxs(TransitionGroup, {
      component: null,
      appear: true,
      children: [!previewImageSrc && !didError && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: FADE_TRANSITION_DURATION_MS,
        classNames: fadeInCls,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: cx(contentWrapperCls, "preloader"),
          children: /*#__PURE__*/jsx(Throbber, {})
        })
      }, "loading"), didError && !props.title && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: FADE_TRANSITION_DURATION_MS,
        classNames: fadeInCls,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: cx(contentWrapperCls, "errorNoTitle"),
          children: /*#__PURE__*/jsx("div", {
            className: iconCls,
            children: /*#__PURE__*/jsx(PreviewIcon, {
              height: 80
            })
          })
        })
      }, "error-noTitle"), didError && props.title && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: FADE_TRANSITION_DURATION_MS,
        classNames: fadeInCls,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: cx(contentWrapperCls, textCls),
          children: props.title
        })
      }, "error-title"), previewImageSrc && !didError && /*#__PURE__*/jsx(CSSRefTransition, {
        timeout: FADE_TRANSITION_DURATION_MS,
        classNames: fadeInCls,
        children: ref => /*#__PURE__*/jsxs("div", {
          ref: ref,
          className: contentWrapperCls,
          children: [/*#__PURE__*/jsx("img", {
            className: imageCls,
            src: previewImageSrc,
            alt: ""
          }), isGExportImage && /*#__PURE__*/jsx("div", {
            className: iconCls,
            children: /*#__PURE__*/jsx(PreviewIcon, {
              height: 80
            })
          })]
        })
      }, "preview-image")]
    })
  });
}

export { Preview };
//# sourceMappingURL=atom.preview.js.map
